import React, { useState, useEffect, useContext } from "react";

import axios from "axios";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { getUsers, postPermission } from "../../services/ConfigServices";

import AddPermission from "./AddPermission";
import TabPanel from "./TabPanel";
import TabPanelContent from "./TabPanelContent";
import UserService from "../../services/UserService";

import { makeStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'assets/css/customNotifications.css';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,

  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
    textTransform: "none",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontWeight: "600",
  },
  tabPanel: {
    marginTop: '-1.0rem',
    marginLeft: '1rem',
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function VerticalTabs() {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup,setPage } = appContext;

  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [permissionsList, setPermissionsList] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const handleTabChange = (event, newValue) => {
    console.log("change tab, new value",newValue);
    setValue(newValue);
  };

  const handleNewPermission = () => {
    axios
      .post(
        postPermission(),
        {
          name: "Nouvelle permission",
          groups: chartIdGroup[0],
          detail: ["mem_access"],
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if(res.status==200) {
          NotificationManager.success("Permission créée");
          setValue(res.data.id);
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
        refreshTable();
      })
      .catch(() => { 
        NotificationManager.error("Une erreur est survenue");
      });
  };

  useEffect(() => {
    setPage('permissions');
    if (chartIdGroup && chartIdGroup[0] !== "0") 
    {
      axios
        .get(
          getUsers(chartIdGroup),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          setPermissionsList(res.data.permissions);
          if(value==0 && res.data.permissions?.length > 0)
          {
            setValue(res.data.permissions[0].id);
          }
        });
    }
  }, [refresh,chartIdGroup]);

  const refreshTable = () => {
    setRefresh(!refresh);
  };

  return (
    <div className={classes.root}>
      <div>
        <AddPermission handleNewPermission={handleNewPermission} />
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleTabChange}
          aria-label="Vertical tabs"
          className={classes.tabs}
          indicatorColor="primary"
          TabIndicatorProps={{ style: { background: "#91C73C" } }}
        >
          {permissionsList?.map(({ id, name }) => (
            <Tab
              key={id}
              className={classes.tab}
              label={name}
              value={id}
              {...a11yProps(id)}
            />
          ))}
        </Tabs>
      </div>
      {permissionsList?.map(({ id, name }, index) => (
        <TabPanel key={id} value={value} index={id} className={classes.tabPanel}>
          <TabPanelContent
            id={id}
            fetchData={refreshTable}
            setValue={setValue}
          />
        </TabPanel>
      ))}
      
    </div>
  );
}
